import React, { useEffect, useState, memo } from 'react'
import { root_categories } from './Amazon'
import { rates } from '../modules/provider'
import useData from '../hooks/useData'
import useInterval from '../hooks/useInterval'
import { ensureArray } from '../modules/helpers'
import provider from '../modules/provider'
import { Link } from 'react-router-dom'
import Loading from './Loading'
import Icon from './Icon'

const endpoint = { value: 'FR' }
const trackingID = 'cartablecuir-21'

const getTopNode = node => {
    // console.log(node)
    let candidate = node.BrowseNodeId
    if (node.Ancestors && node.Ancestors.BrowseNode) {
        candidate = getTopNode(node.Ancestors.BrowseNode)
    }
    return candidate
}
const getSearchIndex = node => {
    const top_node = getTopNode(node)
    // console.log({top_node})
    const searchIndex = top_node && root_categories.find(i => i.id == top_node)
    return searchIndex && searchIndex.us_label
}

const crawl_cache = {
    ts_array_init: false,
    ts_array: [],
    get_ts_array: node_id => {
        if (!crawl_cache.ts_array_init) {
            const ls_ts_array = localStorage.getItem('ts_array_' + node_id)
            return (ls_ts_array && JSON.parse(ls_ts_array)) || []
        } else {
            return crawl_cache.ts_array
        }
    },
    node_array_init: false,
    node_array: [],
    get_node_array: node_id => {
        if (!crawl_cache.node_array_init) {
            const ls_node_array = localStorage.getItem('node_array_' + node_id)
            return (ls_node_array && JSON.parse(ls_node_array)) || []
        } else {
            return crawl_cache.node_array
        }
    }
}

const Node = memo(props => {
    const candidate = crawl_cache.get_node_array(props.root_node_id).find(c => c.BrowseNodeId == props.id)
    // candidate && console.log('loading from candidate')
    const providerData = useData({ url: 'provider/amazon/search?endpoint=' + endpoint.value + '&AssociateTag=' + trackingID + '&Operation=BrowseNodeLookup&BrowseNodeId=' + props.id, transform: data => ({ ...data.BrowseNodes.BrowseNode, TopItemSet: undefined }) }, [props.id, !candidate])
    // console.log(providerData)
    useEffect(() => {
        !candidate && providerData.isReady && providerData.data && crawl_cache.node_array.push(providerData.data)
    }, [providerData.isReady])

    const node = candidate || (providerData.isReady && providerData.data) || {}
    const ItemId =
        (node &&
            node.TopItemSet &&
            node.TopItemSet.TopItem &&
            ensureArray(node.TopItemSet.TopItem)
                .map(item => item.ASIN)
                .join(',')) ||
        null
    const searchIndex = node && getSearchIndex(node)
    // const ProductDetailsUrl =
    //     (searchIndex && 'provider/amazon/search?Operation=ItemSearch&SearchIndex=' + searchIndex + '&BrowseNode=' + props.id + '&endpoint=' + endpoint.value + '&AssociateTag=' + trackingID + '&Sort=salesrank') ||
    //     'provider/amazon/search?Operation=ItemLookup&ItemId=' + ItemId + '&IdType=ASIN&endpoint=' + endpoint.value + '&AssociateTag=' + trackingID + '&ResponseGroup=BrowseNodes,ItemAttributes,Offers,SalesRank,VariationSummary'


    const data = (candidate && candidate.Children && candidate.Children.BrowseNode && ensureArray(candidate.Children.BrowseNode)) || (providerData.isReady && providerData.data.Children && providerData.data.Children.BrowseNode && ensureArray(providerData.data.Children.BrowseNode)) || []
    // const product_array = (ts_candidate && ts_candidate.product_array) || product_data

    return (
        <>
            {props.label} - {props.rate}%
            {(data.length && (
                <ul>
                    {ensureArray(data)
                        .map(c => ({ id: c.BrowseNodeId, label: c.Name }))
                        .map(c => (
                            <li key={c.id}>
                                <Node root_node_id={props.root_node_id} {...c} rate={props.rate} depth={parseInt(props.depth) + 1} />
                                {/* {(product_array.length && (
                                    <ul>
                                        {product_array.map(p => (
                                            <li key={`${props.id}-${p.ASIN}`}>
                                                {p.label} - {p.formatted_price} - {(p.price && p.price) || <span className='badge badge-danger'>NO PRICE FOUND</span>}
                                                {(!p.available && <span className='badge badge-danger'>UNAVAILABLE</span>) || ' - available'} ({p.ASIN})
                                            </li>
                                        ))}
                                    </ul>
                                )) ||
                                    null} */}
                            </li>
                        ))}
                </ul>
            )) ||
                (providerData.idLoading && 'loading...')}
        </>
    )
})
let counter = 0
// let counter_loading = 0
let loading = []
let loaded = []
// let counter_finished = 0

const DisplayNode = props => {
    const children_array = (props.Children && ensureArray(props.Children)) || []
    const { timer } = props
    // const [localCounter, setLocalCounter] = useState(0)
    useEffect(() => {
        counter++
        // setLocalCounter(counter)
    }, [])

    const searchIndex = getSearchIndex(props)
    const topSellers = useData({ url: 'provider_top_seller?provider=amazon&scope=crawl&SearchIndex=' + searchIndex + '&external_provider_node_id=' + props.BrowseNodeId + '&endpoint=' + endpoint.value + '&AssociateTag=' + trackingID + '&page=1' }, [
        props.BrowseNodeId,
        ~loading.indexOf(props.BrowseNodeId) || ~loaded.indexOf(props.BrowseNodeId)
    ])
    // console.log(~loading.indexOf(props.BrowseNodeId) || ~loaded.indexOf(props.BrowseNodeId), loading, loaded)
    loading.length <= 3 && !~loading.indexOf(props.BrowseNodeId) && loading.push(props.BrowseNodeId)
    ;(topSellers.isReady || topSellers.isError) && ~loading.indexOf(props.BrowseNodeId) && (loading = loading.filter(i => i != props.BrowseNodeId))
    ;(topSellers.isReady || topSellers.isError) && !~loaded.indexOf(props.BrowseNodeId) && loaded.push(props.BrowseNodeId)

    // const status = topSellers.isLoading ? 'loading' : (topSellers.isReady && 'done') || 'waiting'
    // useEffect(() => {
    // }, [topSellers.isLoading, topSellers.isReady])
    // console.log({ topSellers })
    // topSellers.isReady && console.log('READY')
    return (
        <>
            <li>
                <Link to={`/provider/amazon/crawl/${props.BrowseNodeId}`}>
                    {props.Name}
                    {(topSellers.isLoading && ' - loading...') || null}
                    {(topSellers.isReady && (
                        <>
                            <Icon name='check' className='mx-2' />
                            {(topSellers.data.average_commission && <>{parseInt(topSellers.data.average_commission) / 100} EUR</>) || null}
                        </>
                    )) ||
                        null}
                    {(topSellers.isError && (
                        <>
                            <Icon name='close' className='text-danger' />
                            {JSON.stringify(topSellers.isError)}
                        </>
                    )) ||
                        null}
                </Link>
            </li>
            {(children_array.length && <ul>{children_array.map(c => (c && c.BrowseNodes && c.BrowseNodes.BrowseNode && <DisplayNode timer={timer} {...c.BrowseNodes.BrowseNode} key={`display-node-${c.BrowseNodes.BrowseNode.BrowseNodeId}`} />) || null)}</ul>) || null}
        </>
    )
}

// const findRate = id => {
//     if (!id) return 0
//     const val = rates.find(r => r.BrowseNodes.find(t => t.id == id))
//     return (val && val.rate) || 0
// }
const AmazonCrawl = props => {
    const [counter, setCounter] = useState(0)
    const [timer, setTimer] = useState(0)
    const node_id = props.match.params.node_id
    const node = root_categories.find(c => c.id == node_id)
    // const save = () => {
    //     localStorage.setItem('node_array_' + node_id, JSON.stringify(crawl_cache.node_array))
    //     localStorage.setItem('ts_array_' + node_id, JSON.stringify(crawl_cache.ts_array))
    // }
    // console.log({ counter_loading })

    const nodeTree = useData('provider/amazon/get_node_tree?scope=crawl&endpoint=' + endpoint.value + '&AssociateTag=' + trackingID + '&BrowseNodeId=' + node_id, [node_id])
    useInterval(() => nodeTree.isReady && setTimer(timer + 1), 1000)
    // console.log({ timer })
    // console.log({ nodeTree })
    // const [nodesNb, setNodesNb] = useState(0)
    // const [topSellersNb, setTopSellersNb] = useState(0)

    return (
        <>
            {(node_id && (
                <>
                    {/* <h2>{node.label}</h2> */}
                    {/* <div className='btn btn-primary' onClick={save}>
                        Save
                    </div> */}
                    <br />
                    {(nodeTree.isReady && ensureArray(nodeTree.data.BrowseNodes.BrowseNode).map(n => <DisplayNode timer={timer} counter={counter} setCounter={setCounter} {...n} key={`node-${n.BrowseNodeId}`} />)) || (nodeTree.isLoading && <Loading text='Loading node tree from Amazon' />)}
                    {/* <ul>
                    {/* <Node root_node_id={node.id} {...node} rate={findRate(node.id)} depth={1} /> */}
                </>
            )) || (
                <>
                    <h2 className='mb-4'>Crawl Categories from Amazon</h2>
                    <small>
                        <ul className='list-unstyled text-left' style={{ columnCount: '3' }}>
                            {root_categories
                                .filter(c => c.crawl)
                                .sort((a, b) => a.label.localeCompare(b.label))
                                .map(n => (
                                    <li key={`${n.id}`}>
                                        <Link to={`/provider/amazon/crawl/${n.id}`}>{n.label}</Link>
                                    </li>
                                ))}
                        </ul>
                    </small>
                </>
            )}
        </>
    )
}

export default AmazonCrawl
